// utils/phone-normalize.js
export const sanitizePhoneForState = (value) => {
    if (value == null) return null;

    const s = String(value).trim();

    // Любые «пустые» маркеры → null
    if (s === '' || /^none$/i.test(s) || /^null$/i.test(s)) return null;

    // Удаляем всё, кроме цифр; плюс оставляем только если он был первым символом
    const hasPlus = s.startsWith('+');
    const digits = s.replace(/\D/g, '');

    // Если вообще нет цифр — считаем, что телефона нет
    if (!digits) return null;

    // Возвращаем в «чистом» виде (опциональный + спереди)
    return (hasPlus ? '+' : '') + digits;
};